import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import InvoicingComp from './InvoicingComp';
import './dash.css';

function Invoicing() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <InvoicingComp />
      </div>
    </div>
  );
}

export default Invoicing;
